import React, { useState, useContext } from "react";
import { Link } from "react-router-dom"; 
import AppContext from "../../context/AppContext";
import HomeIcon from "@mui/icons-material/Home";
import GasManagementProfileMenu from "./GasManagementProfileMenu";
import { Button } from "@mui/material";
const GasManagementHeader = () => {


    const { adminAuthInfo, setAdminAuthInfo, logoutAdmin } = useContext(AppContext);

    return <>
        <header className="dashboard-header elem-flex">
            <div className="elem-row">
                <div className="dashboard-logo"><Link to="/"><Button
                >Gestion Carburant</Button></Link></div>
                <div className="dashboard-right-menu">
                    <GasManagementProfileMenu />
                </div>
            </div>
        </header>
    </>
}


export default GasManagementHeader;